import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import PlayersView from 'views/players'; // Import PlayersView component

/**
 * CustomersView class extends JetView to create a customer management interface.
 */
export default class CustomersView extends JetView {
    /**
     * Configures the layout of the CustomersView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for text translation
        return {
            type: 'clean', // Clean layout type
            view: 'form', // Form view
            id: 'a10', // Unique identifier for the form
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    type: 'wide', // Wide layout type
                    responsive: 'a10', // Responsive behavior based on the identifier
                    margin: 10, // Margin around the layout
                    cols: [
                        {
                            localId: 'inner:layout', // Local identifier for inner layout
                            gravity: 4, // Gravity for resizing
                            type: 'wide', // Wide layout type
                            rows: [
                                {
                                    view: 'tabbar', // Tab bar for navigation
                                    localId: 'tabbar', // Local identifier for the tab bar
                                    height: 35, // Height of the tab bar
                                    options: [
                                        {
                                            id: 'customersAggregator.information/customersAggregator.information', // Identifier for the first tab
                                            value: _('Información'), // Translated label for the first tab
                                        },
                                        {
                                            id: 'customersAggregator.reportscustomer/customers.casinoGamesReport', // Identifier for the second tab
                                            value: _('Reportes'), // Translated label for the second tab
                                        },
                                    ],
                                },
                                { $subview: true }, // Placeholder for subview
                            ],
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the CustomersView.
     * Sets up plugins and event listeners.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use Menu plugin with the tab bar
        this.on(
            this.app,
            'person:select',
            (
                person, // Event listener for person selection
            ) => this.setParam('user', person.id, true), // Set user parameter with selected person's ID
        );
    }
}

// FILE DOCUMENTED
